import jsonwebtoken from 'jsonwebtoken'
import store from '../store/index.js'

const tokenExpiryKey = 'tokenExpiry'
const jwtToken = 'accessToken'

const authService = {
  logOut() {
    localStorage.removeItem(tokenExpiryKey)
    localStorage.removeItem('userData')
    localStorage.removeItem(jwtToken)

    store.state.user.loggedIn = false
    store.state.user.userData = null
  },
  setLoginParameters(token) {
    localStorage.setItem(jwtToken, token)
    store.state.user.loggedIn = true
  },
  isAuthenticated() {
    const jwt = localStorage.getItem(jwtToken)
    const decoded = jsonwebtoken.decode(jwt)

    const stillValid = jwt && new Date(Date.now()) < new Date(decoded.validUntil)

    if (!stillValid) {
      // if token expired, log user out completely and delete all data
      this.logOut()
    }

    store.state.user.loggedIn = stillValid

    return stillValid
  }

}

export default authService
